import { IconButton, styled } from '@mui/material';

export const StyledIconButton = styled(IconButton)({
  color: '#19C2E7',
  fontSize: '1rem',
  marginRight: '1rem',
  gap: '0.5rem',
});